module.exports = "/_next/static/images/uv-404-background-604a67bf42cf32eb485161f8d45ee886.png";